module.exports = __webpack_public_path__ + "static/media/hikvision_serial_no.d9854c93.png";